module.exports = __webpack_public_path__ + "static/media/DSC_0173-2.9a50fc7f.jpg";